export const APP_VERSION = import.meta.env?.VITE_APP_VERSION || "dev";

// Recent changes worth surfacing inline. Keep brief, newest first.
export const CHANGELOG = [
  {
    v: "2026.11.04",
    date: "2026-11-04",
    notes: [
      "Live email management in Messages with automatic reminders and payment confirmations",
      "Matching 4 x 6 PDF receipts for Workspace and email, with an ink-saving logo",
      "Larger, blended app branding and automatic release version labels",
    ],
  },
  {
    v: "v1.1",
    date: "2025-09-17",
    notes: [
      "Global version badge (sidebar + mobile top bar) and in-app changelog",
      "Login page shows app version",
      "Printed invoice footer shows app version",
      "Retro dropdown shows phone numbers; payments list Retro badge uses friendly line labels",
      "Build automation: prebuild script sets REACT_APP_VERSION and syncs package.json",
    ],
  },
  {
    v: "v1 (dev)",
    date: "2025-09-17",
    notes: [
      "Restored Retro Billing with reason, amount, and optional line selector",
      "Added Retro badge in payments list and invoice note",
      "Shipping auto-fill from customer, presets, carrier, and inline validation",
      "Invoice prints carrier/service + retro line label when available",
    ],
  },
];
